<template>
  <article class="btn-preview-list-item">
    <ProductCornerFlag v-if="carousel && isShowingByDateRange">
      NEW
    </ProductCornerFlag>
    <header
      class="btn-preview-list-item__header"
      :class="carousel && isShowingByDateRange ? 'new' : ''"
    >
      <h3 class="btn-preview-list-item__subtitle">
        <a :href="`/by-the-numbers/announcements/${announcement.slug}`">
          {{ announcement.name }}
        </a>
      </h3>
      <p class="btn-preview-list-item__date">
        {{ getFormattedDate(announcement.date) }}
      </p>
    </header>
    <main class="btn-preview-list-item__main">
      <p
        :class="
          carousel
            ? 'btn-preview-list-item__carousel-description'
            : 'btn-preview-list-item__description'
        "
      >
        {{ getFormattedBody(announcement.content) }}
      </p>
    </main>
    <footer class="btn-preview-list-item__footer">
      <a
        :href="`/by-the-numbers/announcements/${announcement.slug}`"
        class="btn-preview-list-item__link"
      >
        <template v-if="carousel">Read Article</template>
        <template v-else>Read More</template>
      </a>
    </footer>
  </article>
</template>

<script>
  import ProductCornerFlag from '~/components/products/ProductCornerFlag.vue';

  export default {
    name: 'PreviewAnnouncement',
    components: {
      ProductCornerFlag,
    },
    props: {
      announcement: {
        type: Object,
        required: true,
      },
      carousel: Boolean,
    },
    computed: {
      isShowingByDateRange() {
        if (!this.announcement.date) return false;

        const subjectTimeStamp = new Date(this.announcement.date);
        const currentDateTimeStamp = new Date();

        subjectTimeStamp.setHours(0, 0, 0, 0);
        currentDateTimeStamp.setHours(0, 0, 0, 0);

        if (subjectTimeStamp > currentDateTimeStamp) return false;

        const timeDifference = currentDateTimeStamp - subjectTimeStamp;
        const dayRangeInMilliseconds = 7 * 24 * 60 * 60 * 1000;

        return timeDifference <= dayRangeInMilliseconds;
      },
    },
    methods: {
      getFormattedDate(date) {
        return new Date(date).toLocaleDateString('en-US', {
          month: 'long',
          day: 'numeric',
          year: 'numeric',
        });
      },
      getFormattedBody(body) {
        // STRIP HTML TAGS
        body = body.replace(/<[^>]*>?/gm, '');

        if (body.length <= 200) return body;

        return `${this.shorten(body, 200)}...`;
      },
      shorten(text, max) {
        return text && text.length > max
          ? text.slice(0, max).split(' ').slice(0, -1).join(' ')
          : text;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .btn-preview-list-item {
    position: relative;
    padding: 0;
    margin: 0;

    &__header {
      display: flex;
      flex-direction: column;
    }
    &__header.new {
      margin-right: 65px;
    }

    &__subtitle {
      font-size: 26px;
      color: var(--itr-blue);
      font-weight: 800;
      margin-bottom: 20px;
    }

    &__date {
      font-size: 14px;
      font-weight: 700;
      color: var(--itr-grey-mid);
      text-transform: uppercase;
      margin-bottom: 15px;
    }

    &__main {
      padding: 0;
      margin: 0;
    }

    &__description {
      font-size: 16px;
      margin-bottom: 26px;
    }
    &__carousel-description {
      font-size: 14px;
      margin-bottom: 26px;
    }

    &__footer {
      padding: 0;
      margin: 0;
    }

    &__link {
      font-size: 16px;
      color: var(--itr-green-mid);
      font-weight: 700;
      text-transform: uppercase;
    }
  }
</style>
